<template>
  <span>{{ text.length > 20 ? `${text.substr(0, 20)}\u2026` : text }}</span>
</template>
<script>
  export default {
    props: ["text"],
  };
</script>
